export const ivfTemplates = [
  {
    name: "הסכמה לטיפולי הפרייה חוץ גופית",
    key: "ba96a47d-f562-4978-ac7e-3f9647f202f6"
  },
  {
    name: "הסכמה לטיפולי הפרייה + שימור ביציות מופרות מוקפאות",
    key: "daf4ac41-5f6c-4ad0-89b6-42a7696d7bf8"
  },
  {
    name: "הסכמה לטיפולי הפרייה + הקפאת ביציות",
    key: "14fe96e5-bab0-494d-aaff-69299bc6855e"
  },
  {
    name: "טיפול עם סיכויי הצלחה קלושים",
    key: "16322c8a-556c-4a03-b864-69a5f8dc376f"
  },
  {
    name: "הפרייה חוץ גופית לאישה מתרומת ביציות",
    key: "83612ff5-95d6-45b6-b543-bff273491305"
  },
  {
    name: "הצהרה על מצב בריאותי והסכמה להמשך טיפולי הפריה חוץ גופית",
    key: "76c7e359-a0b9-4641-9f53-0c5b3508431a"
  },
  {
    name: "הזרעה מלאכותית עם זרע של תורם לאישה פנויה",
    key: "ecdd6cb0-3982-41fa-bacd-d3e26096741d"
  },
  {
    name: "הקפאת ביציות",
    key: "59257a57-6b03-4161-ae2f-0fa174809e19"
  },
  {
    name: "הסכמה לשימור ביציות מופרות מוקפאות",
    key: "191eb558-9d72-4f9b-b4ae-da31ccc8a81b"
  },
  {
    name: "הסכמה מדעת PGD",
    key: "f12777b2-c35b-42d6-ae31-a5316f46afbd"
  },
  {
    name: "החזרת עוברים מתרומת ביצית לאחר ביצוע בדיקות גנטיות",
    key: "8bd89d4e-3f07-466b-89ff-8370144b61ad"
  }
];
